import { DateInput } from "@msuite/ui/date-input";
import { NumberInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoiceSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

/** The Skonto the invoice offers. The account it is paid to is its contact's, not edited here. */
export function IncomingInvoiceFormPayment() {
	/** Context */
	const methods = useFormContext<IncomingInvoiceSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<p className="label">{t("incoming_invoices.payment")}</p>
			<div className="grid grid-cols-3 gap-4">
				<NumberInput
					control={methods.control}
					name="skontoRate"
					label={t("incoming_invoices.skonto_rate")}
					variant="decimal"
					formatOptions={{ style: "unit", unit: "percent" }}
					hideButtons
					isRequired={false}
				/>
				<NumberInput
					control={methods.control}
					name="skontoAmount"
					label={t("incoming_invoices.skonto_amount")}
					variant="decimal"
					hideButtons
					isRequired={false}
				/>
				<DateInput
					control={methods.control}
					name="skontoDeadline"
					label={t("incoming_invoices.skonto_deadline")}
					isNullable
				/>
			</div>
		</div>
	);
}
